import { render, staticRenderFns } from "./AboutAffiantGA.vue?vue&type=template&id=a4745a5e"
import script from "./AboutAffiantGA.vue?vue&type=script&lang=ts"
export * from "./AboutAffiantGA.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports